var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "400 -400 1000 1000",
    style: {
      enableBackground: "new 400 -400 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#142641;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-203.54 -212.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1104.9-187.3L997.3,114.3l73.1,0c52.7,0,75.1,41.6,58.5,88.1l-107,299.9H914.4l117.7-330h-55.4L859,502.3 H750.4l241.5-677.1C769.5-124,603.5,74.9,603.5,312.7c0,234,160.8,430.5,378,485l244-685h176.7c36.5,0,82.5,24.6,62.6,80.7 l-99.2,280.1c-12.7,35.8-42.8,43-66.8,43h-108.6l-105.3,295.8c6.2,0.2,12.4,0.4,18.7,0.4c276.1,0,500-223.8,500-500 C1603.5,37,1380.4-186.5,1104.9-187.3L1104.9-187.3z M1313.1,171.5l-102.5,287.6h54.6l102.5-287.6H1313.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/HP.c5ef122cef64a9da382be3d570c4597c.svg";
export { ForwardRef as ReactComponent };